import React from 'react';
import { PrimaryButton, SecondaryButton, FatalErrorNotice, FATAL_ERROR_NOTICE_TYPES } from '@kallidus/common';
import { arrayOf, elementType, node, oneOf, shape, string } from 'prop-types';
import ApplicationPage from '@Generic/ApplicationPage';
import { useTranslation } from 'react-i18next';
import './ErrorPage.less';

const ErrorPage = ({
  title,
  message,
  buttons = [],
  type = FATAL_ERROR_NOTICE_TYPES.INTERNAL_SERVER_ERROR,
  image,
  children,
}) => {
  const { t } = useTranslation();
  return (
    <ApplicationPage className='error-boundary-page'>
      <FatalErrorNotice
        heading={title || t('error-page.something-went-wrong', 'Something went wrong')}
        subHeading={message}
        type={type}
        image={image}
      >
        {children}
        {Boolean(buttons.length) && (
          <div className='error-boundary-buttons'>
            {buttons.map(({ label, isPrimary, ...buttonProps }) => {
              const ButtonComponent = isPrimary ? PrimaryButton : SecondaryButton;
              return (
                <ButtonComponent key={label} className='error-boundary-button' {...buttonProps}>
                  {label}
                </ButtonComponent>
              );
            })}
          </div>
        )}
      </FatalErrorNotice>
    </ApplicationPage>
  );
};

ErrorPage.propTypes = {
  title: string,
  message: string,
  buttons: arrayOf(shape({ label: string })),
  image: elementType,
  type: oneOf(Object.values(FATAL_ERROR_NOTICE_TYPES)),
  children: node,
};

export default ErrorPage;
